import React from 'react';

import {
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
  } from '@mui/material';

  import {
    flowcellLabelToNameByPlatform
} from './canonicalizeMetadata';

function FlowCellSelect(props) {
    const {
        flowCell,
        setFlowCell,
        platform
    } = props;

    const options = {
        ...flowcellLabelToNameByPlatform[platform],
    }

    return (
        <FormControl variant="standard" fullWidth>
            <InputLabel id="flow-cell-select-label">Flow Cell</InputLabel>
            <Select
                fullWidth
                labelId="flow-cell-select-label"
                id="flow-cell-select"
                value={flowCell}
                label="Flow Cell"
                onChange={(event) => setFlowCell(event.target.value)}
            >
                <MenuItem 
                    value="" 
                    sx={{ height: '32px' }}
                >
                </MenuItem>
                {Object.keys(options).map((key) => {
                    return <MenuItem value={key}>{options[key]}</MenuItem>
                })}
            </Select>
            <FormHelperText>Optional</FormHelperText>
        </FormControl>
    );
}

export default FlowCellSelect;